var _circle, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgThumpsUp = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_198_14228)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_14228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2 38C24.4261 38 18.4914 36.7522 17.0305 35.7174C16.6957 35.4739 16.5131 35.1087 16.5131 34.713V22.813C16.5131 22.4478 16.6957 22.0826 16.9696 21.8696C17.0609 21.8087 19.1914 20.1348 21.4131 18.887C24.1827 17.3652 26.1 15.2348 26.5566 13.8957C27.1044 12.2522 27.8957 10 30.3914 10C31.5783 10 32.5522 10.6696 33.0696 11.8261C34.1044 14.2 33.0087 17.487 31.1827 20.0739C32.4 20.3478 33.9218 20.7435 34.8348 21.0174C36.5087 21.5348 37.6044 22.7522 37.8479 24.2435C38.0609 25.7652 37.3001 27.3174 35.687 28.5043C34.5 31.7 32.4609 36.7522 30.9696 37.5739C30.3914 37.8783 29.387 38 28.2 38ZM18.9479 33.9826C21.2609 34.9565 28.3827 35.9609 29.7218 35.4435C30.4218 34.8043 32.2174 30.7261 33.4653 27.287C33.5566 27.0435 33.7087 26.8304 33.9218 26.6783C34.9261 26.0087 35.4435 25.2174 35.3522 24.5478C35.2609 24 34.774 23.5435 34.0435 23.3C32.5218 22.813 28.7479 21.9913 28.687 21.9913C28.2609 21.9 27.9261 21.5957 27.774 21.1696C27.6218 20.7435 27.7435 20.287 28.0479 19.9826C30.787 17.0304 31.274 14.0174 30.7566 12.8C30.6348 12.4348 30.4827 12.4348 30.3914 12.4348C29.7827 12.4348 29.5087 12.8609 28.8696 14.687C28.1392 16.8174 25.6131 19.3739 22.6 21.0174C21.1392 21.8087 19.6783 22.8739 18.9479 23.4217V33.9826ZM14.1392 34.8348V22.6609C14.1392 21.5652 13.2566 20.6826 12.1609 20.6826C11.0653 20.6826 10.1522 21.5652 10.1522 22.6609V34.8043C10.1522 35.9 11.0348 36.7826 12.1305 36.7826C13.2261 36.7826 14.1392 35.9 14.1392 34.8348Z",
    fill: "#38CB89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_14228",
    x1: -1.57279e-7,
    y1: 1.52381,
    x2: 54.7034,
    y2: 9.44942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFFFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5FFDC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_14228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumpsUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumps_up.f5f75804.svg";
export { ForwardRef as ReactComponent };